module.exports = __webpack_public_path__ + "img/preview-lg.99ffda3a.png";